(function(app) {

    app.provider("leaderboardApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function(portalApiGateway) {
                    var service = {};

                    service.get = function() {
                        return portalApiGateway.get("/Leaderboards");
                    }

                    service.getCommissionGroupLeaderboard = function(commissionGroupId) {
                        return portalApiGateway.get("/Leaderboards/CommissionGroup/" + commissionGroupId);
                    }

                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line